import { Expose } from 'class-transformer';
import * as uuid from 'uuid';

import { SnModel } from '@lib/common/models';

export class SnLocationImport extends SnModel {
  @Expose()
  public filename: any;

  @Expose()
  public description: any;

  @Expose()
  public id: string = uuid.v4();

  @Expose()
  public status: any;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
    this.id = uuid.v4();
  }
}
